globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Controllers = appCustomerSpace.Controllers || {};
appCustomerSpace.Controllers.Websites = appCustomerSpace.Controllers.Websites || {};

appCustomerSpace.Controllers.Websites.FaqCategoriesController = (function(superClass) {
  utils.extend(FaqCategoriesController, superClass);

  function FaqCategoriesController() {
    return FaqCategoriesController.__super__.constructor.apply(this, arguments);
  }

  $.extend(FaqCategoriesController.prototype, {
    init: function(){
      this.initEvents();

      return FaqCategoriesController.__super__.init.apply(this, arguments);
    },
    initEvents: function(){
      var $body = $('body');

      $body.on('click', '.btn-update-category', function() {
        var $updateBtn         = $(this);
        var $category          = $updateBtn.closest('.category-row');
        var $updateFormWrapper = $category.find('.category-update-form');
        var $content           = $category.find('.category-label');

        $updateFormWrapper.show().find('.category-label-field').focus();
        $content.hide();
      });

      $body.on('submit', '.category-update-form form',function() {
        var $form  = $(this);
        var $category = $form.closest('.category-row');

        var success_callback = function(data) {
          if(data.response) {
            var $newCategory = $(data.views.partial);

            $category.replaceWith($newCategory);
          }
        }

        $.post(
          $form.attr('action'),
          $form.serialize(),
          success_callback
        );

        return false;
      });
    }
  });

  return FaqCategoriesController;

})(appCustomerSpace.Controllers.Websites.MainController);
